import { render, staticRenderFns } from "./UnifiedOffersTable.vue?vue&type=template&id=bae70602"
import script from "./UnifiedOffersTable.vue?vue&type=script&lang=ts"
export * from "./UnifiedOffersTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports